import { CalibrationDataActionsType, CalibrationDataState, CalibrationDataActions } from './types';

const calibrationDataInitialState: CalibrationDataState = {
    data: undefined,
    loading: false,
    pageNo: 1,
    hitsPerPage: 10,
    errorFetching: undefined,
    errorDownloading: undefined,
    errorAccess: undefined,
};

export const CalibrationDataReducer = (state = calibrationDataInitialState, action: CalibrationDataActionsType): CalibrationDataState => {
    switch (action.type) {
    case CalibrationDataActions.CALIBRATION_DATA_REQUEST:
        return {
            ...state,
            loading: true,
        };
    case CalibrationDataActions.CALIBRATION_DATA_SUCCESS:
        return {
            ...state,
            errorFetching: undefined,
            data: action.payload,
            loading: false,
        };
    case CalibrationDataActions.CALIBRATION_DATA_FAILURE:
        return {
            ...state,
            errorFetching: action.payload,
            loading: false,
        };
    case CalibrationDataActions.CALIBRATION_DATA_FAILURE_ACCESS:
        return {
            ...state,
            errorAccess: action.payload,
        };
    case CalibrationDataActions.REMOVE_ACCESS_ERROR:
        return {
            ...state,
            errorAccess: undefined,
        };
    case CalibrationDataActions.CALIBRATION_DATA_FAILURE_DOWNLOAD:
        return {
            ...state,
            errorDownloading: action.payload,
        };
    case CalibrationDataActions.REMOVE_DOWNLOAD_ERROR:
        return {
            ...state,
            errorDownloading: undefined,
        };
    case CalibrationDataActions.SET_CURRENT_PAGE:
        return {
            ...state,
            pageNo: action.pageNo,
        };
    case CalibrationDataActions.SET_HITS_PER_PAGE:
        return {
            ...state,
            hitsPerPage: action.hitsPerPage,
        };
    case CalibrationDataActions.RESET_STATE:
        return {
            ...state,
            ...calibrationDataInitialState,
        };
    default:
        return {
            ...state,
        };
    }
};
